import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SignInResponse {
  @jsonMember readonly token!: string;
  @jsonMember readonly refreshToken!: string;
}
